import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import EmailFatFingerSuggestion from 'yoda-account-components/lib/components/EmailFatFingerSuggestion/EmailFatFingerSuggestion';
import * as styles from 'yoda-account-components/lib/components/Login/Login.css';
import parseValidation from 'yoda-account-components/lib/common/parseValidation';
import EmailAutoSuggestInput from 'yoda-account-components/lib/components/EmailAutoSuggestInput/EmailAutoSuggestInput';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as customStyles from './PromoSMSEmailWrapper.css';

const cx = classNames.bind({ ...styles, ...customStyles });

class PromoEmail extends Component {
    static defaultProps = {
        featureFlags: {},
        preferences: {},
        placeholder: '',
    };

    static propTypes = {
        featureFlags: PropTypes.object,
        preferences: PropTypes.object,
        emailInfo: PropTypes.func.isRequired,
        placeholder: PropTypes.string,
    };

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            emailFocus: false,
            emailValid: true,
            emailErrorType: '',
            isEmailValidInput: false,
            emailBlur: false,
        };
        this.setEmailClientValidation = this.setEmailClientValidation.bind(this);
        this.onInputFocus = this.onInputFocus.bind(this);
        this.emailKeyPress = this.emailKeyPress.bind(this);
    }

    onInputFocus(event) {
        if (event.target.name === 'email') {
            this.setState({
                emailFocus: true,
                emailValid: true,
                isEmailValidInput: false,
                emailErrorType: '',
            });
        }
    }

    onFatFingerClick = (value) => {
        this.setState({ email: value, isEmailValidInput: !!value });
        this.props.emailInfo({ isEmailValidInput: !!value, email: value });
    };

    setEmailClientValidation = (value) => {
        const {
            featureFlags: {
                enableEmailAutosuggestion = true,
                enableSignInValidationOnMouseDown = true,
            } = {},
        } = this.props;
        const { preferences: { signin: { errorTypeEmail = '' } = {} } = {} } = this.props;
        const { email } = this.state;
        let isEmailValidInput = !!value;
        if (
            (enableEmailAutosuggestion && enableSignInValidationOnMouseDown) ||
            !enableEmailAutosuggestion
        ) {
            isEmailValidInput = !value || !parseValidation('email', value);
            this.setState({
                emailValid: isEmailValidInput,
                emailErrorType: isEmailValidInput ? '' : errorTypeEmail,
            });
        }
        this.setState({ isEmailValidInput, emailBlur: true }, () => {
            this.props.emailInfo({ isEmailValidInput, email });
        });
    };

    onEmailBlur = (event) => {
        event.preventDefault();
        const {
            featureFlags: {
                enableEmailAutosuggestion = true,
                enableSignInValidationOnMouseDown = true,
            } = {},
        } = this.props;
        if (enableEmailAutosuggestion && enableSignInValidationOnMouseDown) {
            const { email = '' } = this.state;
            this.setEmailClientValidation(email);
        } else {
            const { target: { value = '' } = {} } = event;
            this.setEmailClientValidation(value);
        }
        this.setState({ emailFocus: false });
    };

    emailKeyPress(value, supportFEValidation) {
        this.setState({ email: value });
        this.props.emailInfo({ email: value });
        if (supportFEValidation) {
            this.setEmailClientValidation(value);
        }
    }

    render() {
        const { featureFlags, preferences, placeholder = '' } = this.props;
        const {
            enableSignInValidationOnMouseDown = true,
            enableEmailAutosuggestion = true,
        } = featureFlags;
        const { promotionalSignup } = preferences;
        const {
            email,
            emailFocus,
            emailValid,
            emailErrorType,
            isEmailValidInput,
            emailBlur,
        } = this.state;
        const convertLabelToAnimatingLegend = true;
        const isEmailErrorAvail =
            emailValid === false &&
            (emailErrorType === 'ERROR_TYPE_EMAIL' ||
                emailErrorType === 'ERROR_TYPE_EMAIL_PASSWORD');

        const errorLabelValue = convertLabelToAnimatingLegend && isEmailErrorAvail;

        const emailInputTheme = `${cx(
            'input',
            'inputEmail',
            isEmailErrorAvail ? 'errorField' : null,
            !!email && !isEmailValidInput && emailBlur ? 'errorTextField' : null
        )} ${dt(['border', 'border-solid', 'border-gray-60'])}`;
        return (
            <div className={`${cx('promoEmailWrapper')} ${dt(['mb-6'])}`}>
                <div className={cx('loginBox', 'promoEmailBox')}>
                    <div
                        className={cx('signinFormGroup', 'emailFormGroup', {
                            invalid: convertLabelToAnimatingLegend,
                            animatingLabel: convertLabelToAnimatingLegend,
                        })}
                        data-automation-id="email_id_group"
                    >
                        <label
                            data-automation-id="email_id_label"
                            className={cx('label', 'left', {
                                focusedInput: emailFocus || !!email,
                                errorLabel: errorLabelValue,
                            })}
                            htmlFor={!enableEmailAutosuggestion ? 'loginEmail' : 'promoEmail'}
                        >
                            Email
                        </label>
                        {!enableEmailAutosuggestion ? (
                            <input
                                data-automation-id="email_id_input"
                                className={emailInputTheme}
                                type="email"
                                name="email"
                                value={email}
                                placeholder={convertLabelToAnimatingLegend ? ' ' : placeholder}
                                onFocus={this.onInputFocus}
                                onChange={(e) => {
                                    this.emailKeyPress(e.target.value);
                                }}
                                onBlur={this.onEmailBlur}
                                id="loginEmail"
                                maxLength="70"
                                minLength="1"
                            />
                        ) : (
                            <EmailAutoSuggestInput
                                name="email"
                                type="email"
                                theme={emailInputTheme}
                                placeholder={convertLabelToAnimatingLegend ? ' ' : placeholder}
                                onChange={this.emailKeyPress}
                                onFocus={this.onInputFocus}
                                ariaRequired
                                required
                                value={email}
                                convertLabelToAnimatingLegend
                                onBlur={this.onEmailBlur}
                                id="promoEmail"
                                supportFEValidation={enableSignInValidationOnMouseDown}
                            />
                        )}

                        {isEmailErrorAvail && (
                            <span
                                className={`${cx('inlineError')} ${dt([
                                    'text-error-border',
                                    'text-left',
                                    'text-small',
                                    'block',
                                ])}`}
                                data-automation-id="email_id_inline_error"
                            >
                                {promotionalSignup?.emptyEmailErrorMessage}
                            </span>
                        )}
                        {emailBlur && isEmailValidInput && (
                            <EmailFatFingerSuggestion
                                email={email}
                                onClick={this.onFatFingerClick}
                                featureFlags={featureFlags}
                                preferences={preferences}
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default PromoEmail;
